'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _desc, _value, _class2;

var _promotion = require('redux/modules/promotion');

var _components = require('components');

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _Loading = require('../../components/Loading/Loading');

var _Loading2 = _interopRequireDefault(_Loading);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactSelect = require('react-select');

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _translations = require('translations');

var _translations2 = _interopRequireDefault(_translations);

var _coreDecorators = require('core-decorators');

var _reactRedux = require('react-redux');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _reachHistory = require('../../helpers/reachHistory');

var _NewPromotions = require('./NewPromotions.scss');

var _NewPromotions2 = _interopRequireDefault(_NewPromotions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var md = {
  delete: require('react-icons/lib/md/delete'),
  arrowBack: require('react-icons/lib/md/arrow-back')
};

var NewPromotion = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    list: state.promotions.list,
    user: state.auth.data.user
  };
}, {
  createPromotions: _promotion.createPromotions,
  updatePromotions: _promotion.updatePromotions,
  updatePromotionStatus: _promotion.updatePromotionStatus,
  getPromotions: _promotion.getPromotions,
  push: _reachHistory.push
}), _dec(_class = (_class2 = function (_React$Component) {
  (0, _inherits3.default)(NewPromotion, _React$Component);

  function NewPromotion(props) {
    (0, _classCallCheck3.default)(this, NewPromotion);

    var _this = (0, _possibleConstructorReturn3.default)(this, (NewPromotion.__proto__ || (0, _getPrototypeOf2.default)(NewPromotion)).call(this, props));

    _this.handleInformation = function () {
      if (_this.state.isEdit && _this.state.data.name === null && _this.props.list.length > 0) {
        var promotion = _this.props.list.filter(function (item) {
          return item._id === _this.state.isEdit;
        });

        var start_date = (0, _moment2.default)(promotion[0].start_date).format();
        var end_date = (0, _moment2.default)(promotion[0].end_date).format();
        var selectedMinute = (0, _moment2.default)('' + start_date, 'YYYY-MM-DD HH:mm:ss').format('m');
        var selectedHour = (0, _moment2.default)(start_date).format('H');
        var selectedMinuteEnd = (0, _moment2.default)('' + end_date, 'YYYY-MM-DD HH:mm:ss').format('m');
        var selectedHourEnd = (0, _moment2.default)(end_date).format('H');
        var hour = (0, _moment2.default)('' + start_date, 'YYYY-MM-DD HH:mm:ss').format('HH:mm:ss');
        var hourEnd = (0, _moment2.default)('' + end_date, 'YYYY-MM-DD HH:mm:ss').format('HH:mm:ss');

        _this.setState({
          data: promotion[0],
          selectedMinute: selectedMinute,
          selectedHour: selectedHour,
          selectedMinuteEnd: selectedMinuteEnd,
          selectedHourEnd: selectedHourEnd,
          hour: hour,
          hourEnd: hourEnd,
          save: 'Modificar',
          saveBegin: 'Modificar e iniciar'
        });
        _this.state.data = promotion[0];
      }
    };

    _this.validationData = function (action) {
      var _this$state = _this.state,
          data = _this$state.data,
          selectedHourEnd = _this$state.selectedHourEnd,
          selectedHour = _this$state.selectedHour,
          errors = _this$state.errors;

      var start = (0, _moment2.default)(data.start_date).valueOf();
      var end = (0, _moment2.default)(data.end_date).valueOf();
      if (!data.name) {
        _this.setState({ validName: false });
      } else if (!data.description) {
        _this.setState({ validDescription: false });
      } else if (!data.keyword) {
        _this.setState({ valid: false });
      } else if (!data.action.text) {
        _this.setState({ validMessage: false });
      } else if (selectedHour == 0 || null || '') {
        _this.setState({ startDateValidation: false });
      } else if (selectedHourEnd == 0 || null || '') {
        _this.setState({ endDateValidation: false });
      } else if (start > end) {
        _this.setState({ dateValidation: false });
      } else if (!_this.state.errorMessage && _this.state.isEdit === false) {
        _this.handleCreatePromotion(action);
      } else if (_this.state.isEdit) {
        _this.handleUpdatePromotion(action);
      }
    };

    _this.checkName = function () {
      var data = _this.state.data;

      var temp = data.name ? data.name.trim() : undefined;
      if (!temp) {
        _this.setState({ validName: false });
      }
    };

    _this.checkDescription = function () {
      var data = _this.state.data;

      var temp = data.description ? data.description.trim() : undefined;
      if (!temp) {
        _this.setState({ validDescription: false });
      }
    };

    _this.checkKeyword = function () {
      var data = _this.state.data;

      var temp = data.keyword ? data.keyword.trim() : undefined;
      if (!temp) {
        _this.setState({ valid: false });
      }
    };

    _this.checkMessage = function () {
      var data = _this.state.data;

      var temp = data.action.text ? data.action.text.trim() : undefined;
      if (!temp) {
        _this.setState({ validMessage: false });
      }
    };

    _this.handleCreatePromotion = function (action) {
      var data = _this.state.data;
      data.status = 'NEW';

      _this.props.createPromotions(data).then(function (result) {
        var params = { 'promotion_uid': result._id };
        if (action) _this.props.updatePromotionStatus(params, 'ACTIVE').then(_this.pathCreatePromotion);else _this.pathCreatePromotion();
      });
    };

    _this.handleUpdatePromotion = function (action) {
      var params = { 'promotion_uid': _this.state.data._id };
      var data = _this.state.data;

      _this.props.updatePromotions(params, data).then(function () {
        if (action) _this.props.updatePromotionStatus(params, 'ACTIVE').then(_this.pathUpdatePromotion);else _this.pathUpdatePromotion();
      });
    };

    _this.handleStartDateChange = function (date) {
      var data = _this.state.data;
      var newdate = date.format('YYYY-MM-DD');
      var hour = _this.state.hour;
      var full = newdate + ' ' + hour;
      data['start_date'] = full;
      _this.setState({ data: data });
    };

    _this.handleEndDateChange = function (date) {
      var data = _this.state.data;
      var dateValidation = void 0;
      var start = (0, _moment2.default)(data.start_date).valueOf();
      var end = date.valueOf();
      var newdate = date.format('YYYY-MM-DD');
      var hour = _this.state.hourEnd;
      var full = newdate + ' ' + hour;
      data['end_date'] = full;
      dateValidation = start < end ? true : false;
      _this.setState({ data: data, dateValidation: dateValidation });
    };

    _this.state = {
      colors: _this.colors,
      selectedDate: (0, _moment2.default)().format('YYYY-MM-DD'),
      selectedDates: _this.selectedDates,
      selectedHour: 0,
      selectedMinute: 0,
      selectedHourEnd: 0,
      selectedMinuteEnd: 0,
      length: 0,
      hour: (0, _moment2.default)().format('HH:mm:ss'),
      hourEnd: (0, _moment2.default)().format('HH:mm:ss'),
      data: {
        name: null,
        action: {
          text: null
        },
        created_by: _this.props.user.username || null,
        keyword: null,
        description: null,
        start_date: (0, _moment2.default)().format('YYYY-MM-DD HH:mm:ss'),
        end_date: (0, _moment2.default)().format('YYYY-MM-DD HH:mm:ss'),
        delay: null
      },
      isEdit: _this.props.params.promotion_uid || false,
      errorMessage: null,
      save: '' + (0, _translations2.default)('JUST SAVE'),
      saveBegin: '' + (0, _translations2.default)('SAVE AND START'),
      loading: false,
      valid: true,
      startDateValidation: true,
      endDateValidation: true,
      validName: true,
      validDescription: true,
      validMessage: true,
      dateValidation: true
    };

    if (_this.props.list.length === 0) _this.props.getPromotions();
    return _this;
  }

  (0, _createClass3.default)(NewPromotion, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.handleInformation();
      this.setState({ loading: true });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.handleInformation();
    }
  }, {
    key: 'getHourOptions',
    value: function getHourOptions() {
      var options = [];
      var i = void 0;
      var thisHour = 0;
      var momentDate = (0, _moment2.default)(this.state.selectedDate, "YYYY-MM-DD");
      if ((0, _moment2.default)().diff(momentDate) > 0) {
        thisHour = (0, _moment2.default)().format('H');
      }

      for (i = thisHour; i <= 23; i++) {
        var value = i;
        var label = '' + (i < 10 ? '0' + i : '' + i);
        var option = { value: value, label: label };
        options.push(option);
      }
      return options;
    }
  }, {
    key: 'getMinuteOptions',
    value: function getMinuteOptions() {
      var options = [];
      var i = void 0;
      var thisMinute = 0;

      if (this.state.hour) {
        if (this.state.hour.value === (0, _moment2.default)().format('H')) {
          thisMinute = (0, _moment2.default)().format('m');
        }
      }

      for (i = thisMinute; i <= 59; i++) {
        var value = i;
        var label = '' + (i < 10 ? '0' + i : '' + i);
        var option = { value: value, label: label };
        options.push(option);
      }
      return options;
    }
  }, {
    key: 'handleName',
    value: function handleName(event) {
      var data = this.state.data;
      var validName = void 0;
      data['name'] = event.target.value;
      validName = event.target.value !== null ? true : false;
      this.setState({ data: data, validName: validName });
    }
  }, {
    key: 'handleDescription',
    value: function handleDescription(event) {
      var data = this.state.data;
      var validDescription = void 0;
      data['description'] = event.target.value;
      validDescription = event.target.value !== null ? true : false;
      this.setState({ data: data, validDescription: validDescription });
    }
  }, {
    key: 'validateKeyword',
    value: function validateKeyword(event, which) {
      var data = this.state.data;
      var valid = false;
      data[which] = event.target.value;
      valid = !/[^0-9a-zA-Z]/.test(event.target.value) ? true : false;
      this.setState({ data: data, valid: valid });
    }
  }, {
    key: 'handleAction',
    value: function handleAction(event) {
      var data = this.state.data;
      var validMessage = void 0;
      data.action.text = event.target.value;
      validMessage = event.target.value !== null ? true : false;

      this.setState({
        data: data,
        length: event.target.value.length,
        validMessage: validMessage
      });
    }
  }, {
    key: 'pathCreatePromotion',
    value: function pathCreatePromotion() {
      this.props.push({
        pathname: '/success',
        state: {
          goTo: '/promotions/',
          message: (0, _translations2.default)('CREATE PROMOTION SUCCESS'),
          modal: true,
          returnTo: '/promotions/'
        }
      });
    }
  }, {
    key: 'pathUpdatePromotion',
    value: function pathUpdatePromotion() {
      this.props.push({
        pathname: '/success',
        state: {
          goTo: '/promotions/',
          message: (0, _translations2.default)('UPDATE PROMOTION SUCCESS'),
          modal: true,
          returnTo: '/promotions/'
        }
      });
    }
  }, {
    key: 'handleHourStartChange',
    value: function handleHourStartChange(value) {
      var startDateValidation = void 0;
      var hour = value.value;
      var minute = this.state.selectedMinute;
      var full = (0, _moment2.default)(hour + ':' + minute, 'HH-m').format('HH:mm:ss');
      var start = this.state.data.start_date;
      start = (0, _moment2.default)('' + start, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD');
      var fullStart = start + ' ' + full;
      var data = this.state.data;
      data.start_date = fullStart;
      startDateValidation = value.value ? true : false;
      this.setState((0, _extends3.default)({}, this.state, {
        hour: full,
        selectedHour: hour,
        data: data,
        startDateValidation: startDateValidation
      }));
    }
  }, {
    key: 'handleHourEndChange',
    value: function handleHourEndChange(value) {
      var endDateValidation = void 0;
      var hour = value.value;
      var minute = this.state.selectedMinuteEnd;
      var full = (0, _moment2.default)(hour + ':' + minute, 'HH-m').format('HH:mm:ss');
      var end = this.state.data.end_date;
      end = (0, _moment2.default)('' + end, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD');
      var fullEnd = end + ' ' + full;
      var data = this.state.data;
      data.end_date = fullEnd;
      endDateValidation = value.value ? true : false;
      this.setState((0, _extends3.default)({}, this.state, {
        hourEnd: full,
        selectedHourEnd: hour,
        data: data,
        endDateValidation: endDateValidation
      }));
    }
  }, {
    key: 'handleMinuteStartChange',
    value: function handleMinuteStartChange(value) {
      var minute = value.value;
      var hour = this.state.selectedHour;
      var full = (0, _moment2.default)(hour + ':' + minute, 'HH-m').format('HH:mm:ss');
      var start = this.state.data.start_date;
      start = (0, _moment2.default)('' + start, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD');
      var fullStart = start + ' ' + full;
      var data = this.state.data;
      data.start_date = fullStart;
      this.setState((0, _extends3.default)({}, this.state, {
        hour: full,
        selectedMinute: minute,
        data: data
      }));
    }
  }, {
    key: 'handleMinuteEndChange',
    value: function handleMinuteEndChange(value) {
      var minute = value.value;
      var hour = this.state.selectedHourEnd;
      var full = (0, _moment2.default)(hour + ':' + minute, 'HH-m').format('HH:mm:ss');
      var end = this.state.data.end_date;
      end = (0, _moment2.default)('' + end, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD');
      var fullEnd = end + ' ' + full;
      var data = this.state.data;
      data.end_date = fullEnd;
      this.setState((0, _extends3.default)({}, this.state, {
        hourEnd: full,
        selectedMinuteEnd: minute,
        data: data
      }));
    }
  }, {
    key: 'handleDelay',
    value: function handleDelay(value) {
      var data = this.state.data;
      data.delay = value.value;
      this.setState({ data: data });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var hourOptions = this.getHourOptions();
      var minuteOptions = this.getMinuteOptions();
      var messageLength = 160;
      var messageLengthMultiple = 154;
      var selectedHour = this.state.selectedHour;
      var selectedHourEnd = this.state.selectedHourEnd;

      if (!this.state.loading) return _react2.default.createElement(_Loading2.default, null);

      return _react2.default.createElement(
        'div',
        { className: _NewPromotions2.default.wrapper },
        _react2.default.createElement(_reactHelmet2.default, { title: this.state.isEdit ? (0, _translations2.default)('EDIT PROMOTION DETAIL') : (0, _translations2.default)('NEW PROMOTION DETAIL') }),
        _react2.default.createElement(
          'div',
          { className: _NewPromotions2.default.bar },
          _react2.default.createElement(
            'div',
            { className: _NewPromotions2.default.icon, onClick: this.props.router.goBack },
            _react2.default.createElement(md.arrowBack, { size: 20, color: '#FFF' })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: _NewPromotions2.default.main },
          _react2.default.createElement(
            'div',
            { className: _NewPromotions2.default.aside },
            _react2.default.createElement(
              'div',
              { className: _NewPromotions2.default.container },
              _react2.default.createElement(
                'div',
                { className: _NewPromotions2.default.text },
                _react2.default.createElement(
                  'label',
                  null,
                  ' ',
                  (0, _translations2.default)('NAME'),
                  ' '
                ),
                _react2.default.createElement('textarea', { onBlur: this.checkName, className: _NewPromotions2.default.messageComposer,
                  value: this.state.data.name, onChange: function onChange(e) {
                    return _this2.handleName(e);
                  } }),
                _react2.default.createElement(
                  'span',
                  null,
                  this.state.validName ? '' : _react2.default.createElement(
                    'div',
                    { className: _NewPromotions2.default.errorStyle },
                    _react2.default.createElement(
                      'h3',
                      null,
                      (0, _translations2.default)('WRONG DATA')
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: _NewPromotions2.default.text },
                _react2.default.createElement(
                  'label',
                  null,
                  ' ',
                  (0, _translations2.default)('DESCRIPTION'),
                  ' '
                ),
                _react2.default.createElement('textarea', { onBlur: this.checkDescription, className: _NewPromotions2.default.description,
                  value: this.state.data.description, onChange: function onChange(e) {
                    return _this2.handleDescription(e);
                  } }),
                _react2.default.createElement(
                  'span',
                  null,
                  this.state.validDescription ? '' : _react2.default.createElement(
                    'div',
                    { className: _NewPromotions2.default.errorStyle },
                    _react2.default.createElement(
                      'h3',
                      null,
                      (0, _translations2.default)('WRONG DATA')
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: _NewPromotions2.default.text },
                _react2.default.createElement(
                  'label',
                  null,
                  ' ',
                  (0, _translations2.default)('KEYWORD'),
                  ' '
                ),
                _react2.default.createElement('textarea', { onBlur: this.checkKeyword, className: _NewPromotions2.default.messageComposer,
                  value: this.state.data.keyword, onChange: function onChange(e) {
                    return _this2.validateKeyword(e, 'keyword');
                  } }),
                _react2.default.createElement(
                  'span',
                  null,
                  this.state.valid ? '' : _react2.default.createElement(
                    'div',
                    { className: _NewPromotions2.default.errorStyle },
                    _react2.default.createElement(
                      'h3',
                      null,
                      (0, _translations2.default)('INVALID KEYWORD')
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: _NewPromotions2.default.text },
                _react2.default.createElement(
                  'label',
                  null,
                  ' ',
                  (0, _translations2.default)('ACTIVATION MESSAGE'),
                  '  '
                ),
                _react2.default.createElement('textarea', { onBlur: this.checkMessage, className: _NewPromotions2.default.activation,
                  value: this.state.data.action.text, onChange: this.handleAction }),
                _react2.default.createElement(
                  'span',
                  { className: _NewPromotions2.default.counter },
                  (0, _translations2.default)('CHARACTERS'),
                  ': ',
                  this.state.length,
                  '\xA0',
                  (0, _translations2.default)('MESSAGES'),
                  ': ',
                  Math.ceil(this.state.length / (this.state.length > messageLength ? messageLengthMultiple : messageLength))
                ),
                _react2.default.createElement(
                  'span',
                  null,
                  this.state.validMessage ? '' : _react2.default.createElement(
                    'div',
                    { className: _NewPromotions2.default.errorStyle },
                    _react2.default.createElement(
                      'h3',
                      null,
                      (0, _translations2.default)('WRONG DATA')
                    )
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: _NewPromotions2.default.calendar },
            _react2.default.createElement(
              'h1',
              null,
              ' ',
              (0, _translations2.default)('PROMOTION DATES'),
              ' '
            ),
            _react2.default.createElement(
              'div',
              { className: _NewPromotions2.default.dates },
              _react2.default.createElement(
                'div',
                { className: _NewPromotions2.default.title },
                ' ',
                (0, _translations2.default)('STARTS'),
                ' '
              ),
              _react2.default.createElement(
                'div',
                { className: _NewPromotions2.default.title },
                ' ',
                (0, _translations2.default)('END'),
                ' '
              )
            ),
            _react2.default.createElement(
              'div',
              { className: _NewPromotions2.default.dates },
              _react2.default.createElement(_components.Datepicker, {
                onChange: function onChange(date) {
                  return _this2.handleStartDateChange(date);
                },
                timeFormat: false,
                currentDate: this.state.data.start_date,
                selectedDate: this.state.data.start_date,
                compact: true
              }),
              _react2.default.createElement(_components.Datepicker, {
                onChange: function onChange(date) {
                  return _this2.handleEndDateChange(date);
                },
                timeFormat: false,
                currentDate: this.state.data.end_date,
                selectedDate: this.state.data.end_date,
                compact: true,
                afterDate: this.state.data.start_date,
                disable: true
              })
            ),
            _react2.default.createElement(
              'div',
              { className: _NewPromotions2.default.dates },
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'h2',
                  null,
                  ' ',
                  (0, _translations2.default)('SELECT HOUR'),
                  ' '
                ),
                _react2.default.createElement(
                  'div',
                  { className: _NewPromotions2.default.hour },
                  _react2.default.createElement(
                    'div',
                    { className: _NewPromotions2.default.selectDate },
                    _react2.default.createElement(_reactSelect2.default, {
                      ref: 'selectedHour',
                      closeMenuOnSelect: false,
                      defaultValue: hourOptions[0],
                      options: hourOptions,
                      placeholder: (0, _translations2.default)('SELECT HOUR'),
                      value: selectedHour,
                      onChange: this.handleHourStartChange
                    })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: _NewPromotions2.default.selectDate },
                    _react2.default.createElement(_reactSelect2.default, {
                      ref: 'selectedMinute',
                      closeMenuOnSelect: false,
                      defaultValue: minuteOptions[0],
                      options: minuteOptions,
                      placeholder: (0, _translations2.default)('SELECT MINUTE'),
                      value: this.state.selectedMinute,
                      onChange: this.handleMinuteStartChange
                    })
                  )
                ),
                this.state.startDateValidation ? '' : _react2.default.createElement(
                  'div',
                  { className: _NewPromotions2.default.dateError },
                  _react2.default.createElement(
                    'h3',
                    null,
                    (0, _translations2.default)('VALID START DATE')
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'h2',
                  null,
                  ' ',
                  (0, _translations2.default)('SELECT HOUR'),
                  ' '
                ),
                _react2.default.createElement(
                  'div',
                  { className: _NewPromotions2.default.hour },
                  _react2.default.createElement(
                    'div',
                    { className: _NewPromotions2.default.selectDate },
                    _react2.default.createElement(_reactSelect2.default, {
                      ref: 'selectedHour',
                      closeMenuOnSelect: false,
                      defaultValue: hourOptions[0],
                      options: hourOptions,
                      placeholder: (0, _translations2.default)('SELECT HOUR'),
                      value: selectedHourEnd,
                      onChange: this.handleHourEndChange
                    })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: _NewPromotions2.default.selectDate },
                    _react2.default.createElement(_reactSelect2.default, {
                      ref: 'selectedMinute',
                      closeMenuOnSelect: false,
                      defaultValue: minuteOptions[0],
                      options: minuteOptions,
                      placeholder: (0, _translations2.default)('SELECT MINUTE'),
                      value: this.state.selectedMinuteEnd,
                      onChange: this.handleMinuteEndChange
                    })
                  )
                ),
                this.state.endDateValidation ? '' : _react2.default.createElement(
                  'div',
                  { className: _NewPromotions2.default.dateError },
                  _react2.default.createElement(
                    'h3',
                    null,
                    (0, _translations2.default)('VALID START DATE')
                  )
                )
              )
            ),
            this.state.dateValidation ? '' : _react2.default.createElement(
              'div',
              { className: _NewPromotions2.default.dateValidation },
              _react2.default.createElement(
                'h3',
                null,
                ' ',
                (0, _translations2.default)('BAD RANGE'),
                ' '
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: _NewPromotions2.default.footer },
          _react2.default.createElement(
            'button',
            { onClick: function onClick() {
                return _this2.validationData();
              }, className: _NewPromotions2.default.activateButton },
            ' ',
            this.state.save,
            ' '
          ),
          _react2.default.createElement(
            'button',
            { onClick: function onClick() {
                return _this2.validationData('ACTIVE');
              }, className: _NewPromotions2.default.saveButton },
            ' ',
            this.state.saveBegin,
            ' '
          )
        )
      );
    }
  }]);
  return NewPromotion;
}(_react2.default.Component), (_applyDecoratedDescriptor(_class2.prototype, 'handleName', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'handleName'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleDescription', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'handleDescription'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'validateKeyword', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'validateKeyword'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleAction', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'handleAction'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'pathCreatePromotion', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'pathCreatePromotion'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'pathUpdatePromotion', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'pathUpdatePromotion'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleHourStartChange', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'handleHourStartChange'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleHourEndChange', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'handleHourEndChange'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleMinuteStartChange', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'handleMinuteStartChange'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleMinuteEndChange', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'handleMinuteEndChange'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleDelay', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'handleDelay'), _class2.prototype)), _class2)) || _class);
exports.default = NewPromotion;
module.exports = exports['default'];